import React from 'react'
import { Check, Loader } from 'lucide-react'
import { AiAvatar } from 'components/CommonComponents/AIAvatar'
import { useAiCreationText } from '../../hooks/useAiCreationText'
import styles from './styles.module.css'

/** The service has one response, so only completed local preparation is marked done while waiting. */
export function AIGenerationProgress({ complete = false }: { complete?: boolean }) {
  const t = useAiCreationText()
  return (
    <section className={styles.progress} role="status" aria-live="polite">
      <AiAvatar listening size={190} />
      <h2>{complete ? t.generationDone : t.generating}</h2>
      <ol>
        <li>
          <Check size={20} />
          {t.prepared}
        </li>
        <li>
          {complete ? <Check size={20} /> : <Loader className={styles.spinner} size={20} />}
          {t.creating}
        </li>
        <li className={complete ? undefined : styles.pending}>
          {complete ? <Check size={20} /> : <span />}
          {t.review}
        </li>
      </ol>
    </section>
  )
}
